import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Subject, tap} from 'rxjs';
import {API_URL} from '../constants';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public $refreshToken = new Subject<Boolean>(); // Observable for refresh token
    public $refreshTokenReceived = new Subject<Boolean>(); // Observable for refresh token received
    private apiUrl = `${API_URL}` + 'auth';
    private userRole: string = ''; // Store user role


    constructor(private http: HttpClient) {
        this.$refreshToken.subscribe((response: any) => {
            this.refreshToken(); // Call refresh token method when event is emitted
        }); // Subscribe to refresh token observable
    }

    setRole(role: string) {
        this.userRole = role; // Set the user's role
    }

    getRole(): string {
        return this.userRole; // Get the user's role
    }

    hasRole(requiredRole: string): boolean {
        return this.userRole === requiredRole; // Check if user has a role
    }

    hasAnyRole(roles: string[]): boolean {
        return roles.includes(this.userRole); // Check if user has any of the given roles
    }


    login(authReq: any) {
        return this.http.post(this.apiUrl + '/' + 'authenticate', authReq);
    }

    /*refreshToken() {
      const refreshToken = {
        'token': sessionStorage.getItem('refresh_token')
      }
      this.http.post(this.apiUrl + '/' +'refresh-token', refreshToken).subscribe((response: any) => {
        if(response !== null) {
          console.log('Refresh token received:', response);
          sessionStorage.setItem('access_token', response.accessToken);
          sessionStorage.setItem('access_token', response.accessToken);
          sessionStorage.setItem('username', response.username);
          sessionStorage.setItem('userRole', response.roles);
          sessionStorage.setItem('userGroup', response.roles);
          sessionStorage.setItem('roleScope', response.roleScope || 'SELF');
          sessionStorage.setItem('rolesPermission', JSON.stringify(response.rolesPermission));
          sessionStorage.setItem('chapter', response.chapterId);
          sessionStorage.setItem('userId', response.userId);
          sessionStorage.setItem('refresh_token', response.refreshToken);
          this.$refreshTokenReceived.next(true); // Emit the refresh token event
        }else{
          sessionStorage.removeItem('access_token');
          sessionStorage.removeItem('username');
          sessionStorage.removeItem('userRole');
          sessionStorage.removeItem('userGroup');
          sessionStorage.removeItem('roleScope');
          sessionStorage.removeItem('rolesPermission');
          sessionStorage.removeItem('chapter');
          sessionStorage.removeItem('userId');
          sessionStorage.removeItem('refresh_token');
        }
      });
    }*/
    refreshToken() {
        const refreshToken = {
            token: sessionStorage.getItem('refresh_token')
        };

        return this.http.post(this.apiUrl + '/refresh-token', refreshToken).pipe(
            tap((response: any) => {
                if (response) {
                    sessionStorage.setItem('access_token', response.accessToken);
                    sessionStorage.setItem('refresh_token', response.refreshToken);
                    sessionStorage.setItem('username', response.username);
                    sessionStorage.setItem('userRole', response.roles);
                    sessionStorage.setItem('userGroup', response.roles);
                    sessionStorage.setItem('roleScope', response.roleScope || 'SELF');
                    sessionStorage.setItem('rolesPermission', JSON.stringify(response.rolesPermission));
                    sessionStorage.setItem('chapter', response.chapterId);
                    sessionStorage.setItem('userId', response.userId);

                    this.$refreshTokenReceived.next(true);
                }
            })
        );
    }


}
